// styles
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const SoFormCandidateBlockDetailsPriceBreakdownTotalPriceDescription = ({
  isSummary,
  className,
}) => {
  const { t } = useTranslation('Catalog');

  const description = isSummary
    ? t('price.total_with_no_vat')
    : t('price.base_with_no_vat');
  return <div className={className}>{description}</div>;
};

export default styled(
  SoFormCandidateBlockDetailsPriceBreakdownTotalPriceDescription
)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;

  width: 468px;
  height: 24px;
`;
